let counter = 0;

// Generates unique ID for HTML elements
export default function generateUniqueId() {
  counter++;
  return `el-${counter}`;
}
